import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { open } = {}) => ({
  orderInfoTitle: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      marginBottom: open ? theme.spacing(2) : theme.spacing(3),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        marginBottom: open ? theme.spacing(2) : theme.spacing(3),
      }),
    },
  },
  root: {
    alignItems: 'flex-start',
    boxShadow: '0px 5px 17px rgba(48, 85, 107, 0.2)',
    borderRadius: 10,
    display: 'flex',
    padding: '8px 16px',
    gap: 10,
    marginBottom: '30px',
    minHeight: 90,
  },
  toggleButton: {
    marginLeft: theme.spacing(1.5),
    backgroundColor: 'white',
    '& svg': {
      height: 14,
      width: 14,
      '& path': {
        stroke: theme.palette.darkGrey,
      },
    },
  },
  orderInfo: {
    [theme.breakpoints.down('md')]: {
      display: 'block',
      fontSize: 14,
      marginBottom: theme.spacing(1),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        display: 'block',
        fontSize: 14,
        marginBottom: theme.spacing(1),
      }),
    },
  },
  orderInfoId: {
    fontWeight: 700,
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(1.5),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        marginBottom: theme.spacing(1.5),
      }),
    },
  },
  lastOrderInfo: {
    marginBottom: theme.spacing(3),
  },
}));
